import { createReducer } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  captureEligibilityTime,
  showDebtModal,
  hideDebtModal,
  setLoanTerm,
  setLoanAmount,
  showCard,
  setRepaymentDay,
  showDebtAmount,
  selectDebtConsolidate,
  financialDetailsChanged,
  hideBeforeScreenModal,
  showBeforeScreenModal,
  selectBeforeScreen,
  updateDebtAmountConsolidate,
  showFinancialValidation
} from 'actionCreators/loanValues';
import { fetchIllustrationSuccessResponse } from 'actionCreators/calculator';
import { calculateRepaymentDate } from 'utils/calculateRepaymentDate';

const tomorrowsDate = moment().add(1, 'day').format('DD');

const initialState = {
  repaymentDay: calculateRepaymentDate(tomorrowsDate).format('DD'),
  repaymentDate: calculateRepaymentDate(tomorrowsDate).format('YYYY-MM-DD'),
  debtAmountConsolidate: 0
};

const loanValuesReducer = createReducer(initialState, (builder) => {
  builder.addCase('setQueryParam', (state, action) => {
    const {
      term,
      amount,
      amountConsolidate,
      debtConsolidate,
      type,
      purpose,
      upiTS,
      eligibilityTime,
      day
    } = action.payload;

    return {
      ...state,
      term: parseInt(term),
      amount: parseFloat(amount),
      purpose: purpose ? decodeURIComponent(purpose) : null,
      upiTS,
      eligibilityTime,
      ...(day && { day }),
      type,
      debtConsolidate: debtConsolidate ? decodeURIComponent(debtConsolidate) : null,
      amountConsolidate: parseFloat(amountConsolidate)
    };
  }),
    builder.addCase(captureEligibilityTime, (state, action) => {
      state.eligibilityTime = action.payload;
    });

  builder.addCase(setLoanTerm, (state, action) => {
    state.term = isNaN(action.payload) ? null : parseInt(action.payload);
  });

  builder.addCase(setLoanAmount, (state, action) => {
    state.amount = isNaN(action.payload) ? null : parseInt(action.payload);
  });

  builder.addCase(setRepaymentDay, (state, action) => {
    state.repaymentDay = moment(action.payload).format('DD');
    state.repaymentDate = moment(action.payload).format('YYYY-MM-DD');
  });

  builder.addCase(showDebtModal, (state) => {
    state.showDebtModal = true;
  });

  builder.addCase(hideDebtModal, (state) => {
    state.showDebtModal = false;
  });

  builder.addCase(showCard, (state, action) => {
    state.showCard = action.payload;
  });

  builder.addCase(showFinancialValidation, (state, action) => {
    state.showFinancialValidation = action.payload;
  });

  builder.addCase(selectBeforeScreen, (state, action) => {
    state.isBeforeScreenSelected = action.payload;
  });

  builder.addCase(hideBeforeScreenModal, (state) => {
    state.showBeforeScreenModal = false;
  });

  builder.addCase(showBeforeScreenModal, (state) => {
    state.showBeforeScreenModal = true;
  });

  builder.addCase(fetchIllustrationSuccessResponse, (state, action) => {
    const { loanAmount, repExampleAmount } = action.payload;

    return {
      ...state,
      ...(!repExampleAmount && { amount: parseInt(loanAmount) })
    };
  });

  builder.addCase(showDebtAmount, (state, action) => {
    state.isDebtAmount = action.payload;
  });

  builder.addCase(selectDebtConsolidate, (state, action) => {
    state.isDebtConsolidateSelected = action.payload;
  });

  builder.addCase(financialDetailsChanged, (state, action) => {
    state.isFinancialDetailsChanged = action.payload;
  });

  builder.addCase(updateDebtAmountConsolidate, (state, action) => {
    state.debtAmountConsolidate = action.payload;
  });
});
export { loanValuesReducer };
